/**
 * FeedbackDashboardPage
 *
 * Page wrapper for Feedback Dashboard.
 *
 * @module pages/dev/FeedbackDashboardPage
 */

import React from 'react';
import FeedbackDashboard from '../../components/dev/FeedbackDashboard';

/**
 * FeedbackDashboardPage
 */
const FeedbackDashboardPage: React.FC = () => {
  return <FeedbackDashboard />;
};

export default FeedbackDashboardPage;
